






































































































































































/* eslint-disable @typescript-eslint/camelcase */
import API from '@core/services/API'
import { inject } from 'inversify-props'
import { Component, Vue } from 'vue-property-decorator'
import { ClientPolicyMeta } from '../../../model/ClientPolicyMeta'
import AppDatatable from '@core/components/AppDatatableV2.vue'
import { IDateService } from '@master/services/IDateService'
import { startCase } from 'lodash/fp'
import AppDialog from '@core/components/AppDialog.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { UserMeta } from '@core/model/common/UserMeta'
import AppForm from '@core/components/AppForm.vue'
import CSVImport from '@core/services/csv/CSVImport.vue'
import { AMLCsvModel } from '../../../csv-model/AMLCsvModel'
// import { ExistingPolicyCsvModel } from '../../../csv-model/ExistingPolicyCsvModel'
import { CompanyDetailsMeta } from '@core/pages/companyDetails/model/CompanyDetailsMeta'
import { download } from 'papaparse'
import FilterIcon from '@core/assets/filter.svg'
import { ClientPolicySearchDTO, ClientPolicyService, ManualNbrDTOV2, ReconReportDTO } from '../../../api'
import { namespace } from 'vuex-class'
import { ProductFullMetaList } from '@master/model/common/ProductFullMetaList'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { ClientResponseDto } from '@core/pages/client-management/api'
import { CompanyDetailsMetaList } from '@core/pages/companyDetails/model/CompanyDetailsMetaList'
import { NbrCsvImportModelV2 } from '@core/pages/new-business-register/csv-model/NbrCSVImportModelV2'
import { LineOfBusinessOptions } from '@master/model/options/LineOfBusinessOptions'
import PolicyDashboardComponent from '../PolicyDashboardComponent.vue'
import { ReconReportSearchCriteria } from '../model/ReconReportDTO'

type Tab = 'pending' | 'pending-cis-funds' | 'approved' | 'rejected' | 'dashboard'

class ManualNbrParams implements ManualNbrDTOV2 {
  adviserOid: string
  clientOid: string
  lineOfBusiness: string
  applicationDate: number
  mainNbrOid?: string
}

const clientPolicyStore = namespace('ClientPolicyStore')
const clientStore = namespace('ClientStore')
const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppDatatable,
    AppDialog,
    AppForm,
    PolicyDashboardComponent,
    CSVImport
  }
})
export default class ClientPolicyList extends Vue {
  @inject()
  private $api: API

  @inject()
  private dateService: IDateService

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  // Things related to clients

  @clientStore.Action
  private retrieveClientList

  @clientStore.State
  private clientList: ClientResponseDto[]

  @clientStore.State
  private corporateList: ClientResponseDto[]

  @clientStore.State
  private individualList: ClientResponseDto[]

  // End of things related to clients

  private tab: Tab = 'pending'
  private txtSearch = ''

  private newBusiness: ManualNbrParams = new ManualNbrParams()
  private newBusinessModal = false
  private savingInProgress = false

  private exportFilter: ClientPolicySearchDTO = {
    principalOids: [],
    adviserOids: [],
    creationStartDate: null,
    creationEndDate: null,
    status: null,
    opsApprovalStartDate: undefined,
    opsApprovalEndDate: undefined,
    policyNumberContains: undefined,
    mainOwnerOids: undefined,
    supervisorOids: undefined,
    servicingOids: undefined,
    page: undefined,
    size: undefined
  }

  private pendingPolicies = []
  private pendingRecordsTotal = 0
  private pendingCISPolicies = []
  private pendingCISRecordsTotal = 0
  private approvedPolicies = []
  private approvedRecordsTotal = 0
  private rejectedPolicies = []
  private rejectedRecordsTotal = 0
  private searchTimeout = null
  private userList: UserMeta[] = []
  private companyList: CompanyDetailsMeta[] = []

  private amlModal = false
  private currentDatatablePage = 1
  private massImport = false

  private filterModal = false
  private filteredData = []
  private filters = []
  private filterModel = {
    from: null,
    to: null
  }

  private massImportValidationErrors: Array<string[]> = []
  private rejectedPolicyToBeDeleted: string[] = []
  private isImporting = false
  private isImportingNBR = false

  private queryHeaders = [
    '_oid',
    'client_oid',
    'product_oid',
    'business_id',
    'owners_name',
    'principal',
    'name',
    'application_date',
    'ops_approval_date',
    'status',
    'type',
    'policy_number',
    'creation_type'
  ]

  private queryHeadersV2 = [
    'oid',
    'clientOid',
    'productOid',
    'businessId',
    'ownersName',
    'principal',
    'name',
    'applicationDate',
    'opsApprovalDate',
    'status',
    'type',
    'policyNumber',
    'creationType'
  ]

  private pageSize = 10

  handleRejectedPolicySelection (rows: ClientPolicyMeta[]) {
    this.rejectedPolicyToBeDeleted = rows.map(e => e.oid)
  }

  async deleteSelectedRejectedPolicy () {
    if (!confirm('Are you sure to delete the selected rejected policies?')) {
      return
    }

    await ClientPolicyService.deletePolicies(this.rejectedPolicyToBeDeleted)
    this.rejectedPolicyToBeDeleted = []
    await this.uiService.alert.show({
      type: 'success',
      message: 'Selected rejected policies has been deleted'
    })

    window.location.reload()
  }

  importAmlModal () {
    this.amlModal = true
  }

  get filterIcon () {
    return FilterIcon
  }

  get companyOptions () {
    return this.companyList.map(company => {
      return {
        label: company.companyDetailsName,
        value: company.oid
      }
    }).sort((a, b) => {
      const textA = a.label.toUpperCase()
      const textB = b.label.toUpperCase()
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    })
  }

  get adviserOptions () {
    return this.userList.map(user => {
      return {
        label: user.names.length > 0 ? user.names[0] : '',
        value: user.oid
      }
    }).sort((a, b) => {
      const textA = a.label.toUpperCase()
      const textB = b.label.toUpperCase()
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    })
  }

  get exportFilterFormStructure (): FormStructure<any> {
    return [
      {
        label: 'Company',
        options: [{ label: 'All Companies', value: '' }, ...this.companyList.map(company => {
          return {
            label: company.companyDetailsName,
            value: company.oid
          }
        })],
        key: 'companyOid'
      },
      {
        label: 'User',
        options: [{ label: 'All Users', value: '' }, ...this.userList.map(user => {
          return {
            label: user.names[0],
            value: user.oid
          }
        })],
        key: 'userOid'
      },
      {
        label: 'Start Date',
        type: 'date',
        key: 'startDate'
      },
      {
        label: 'End Date',
        type: 'date',
        key: 'endDate'
      },
      {
        label: 'Status',
        options: [
          { label: 'Approved', value: 'approved_by_ops' },
          { label: 'Pending', value: 'new' }
        ],
        key: 'status'
      }
    ]
  }

  get newBusinessFormStructure (): FormStructure<ManualNbrDTOV2> {
    return [
      {
        label: 'Line of Business',
        options: LineOfBusinessOptions,
        key: 'lineOfBusiness'
      },
      {
        label: 'Representative',
        options: this.userList
          .filter(user => ['adviser', 'supervisor', 'director'].includes(user.systemrole?.toLowerCase()) && user.status === 'active')
          .map(user => {
            return {
              label: user.names.length > 0 ? user.names[0] : '',
              value: user.oid
            }
          })
          .sort((userA, userB) => userA.label.toLowerCase().localeCompare(userB.label.toLowerCase())),
        key: 'adviserOid',
        classes: ['colspan']
      },
      {
        label: 'Entity / Individual',
        key: 'clientOid',
        options: this.clientList.map(client => {
          return {
            label: `${client.name} (${client.clientId || 'unknown'})`,
            value: client.oid
          }
        }).sort((a, b) => a.label.localeCompare(b.label)) // sort alphabetically by name
      },
      {
        label: 'Issuer Application Date',
        type: 'date',
        key: 'applicationDate'
      }
    ]
  }

  get filterFormStructure (): FormStructure<any> {
    return [
      {
        label: 'From',
        type: 'date',
        key: 'from'
      },
      {
        label: 'To',
        type: 'date',
        key: 'to'
      }
    ]
  }

  async getPendingPolicies () {
    const res = await ClientPolicyService.listPoliciesV2({
      pagination: this.currentDatatablePage,
      limit: this.pageSize,
      status: ['new', 'pending'],
      search: this.txtSearch
    })

    this.pendingPolicies = res.data.map(policy => {
      return {
        ...policy,
        applicationDate: this.dateService.format(policy.applicationDate, 'YYYY-MM-DD'),
        opsApprovalDate: policy.opsApprovalDate ? this.dateService.format(policy.opsApprovalDate, 'YYYY-MM-DD') : 'No Ops Approval Date Set',
        status: { new: 'New', pending: 'Pending Approval' }[policy.status],
        type: LineOfBusinessOptions.find(op => op.value === policy.type)?.label || '',
        creationType: startCase(policy.creationType),
        emit: true
      }
    })
    this.pendingRecordsTotal = res.recordsTotal
  }

  async getPendingCISPolicies () {
    const res = await ClientPolicyService.existingListPoliciesV2({
      pagination: this.currentDatatablePage,
      limit: this.pageSize,
      status: ['approved_by_ops'],
      type: ['collectiveinvestmentscheme'],
      search: this.txtSearch
    })
    this.pendingCISPolicies = res.data.map(policy => {
      return {
        ...policy,
        applicationDate: this.dateService.format(policy.applicationDate, 'YYYY-MM-DD'),
        opsApprovalDate: policy.opsApprovalDate ? this.dateService.format(policy.opsApprovalDate, 'YYYY-MM-DD') : 'No Ops Approval Date Set',
        status: { new: 'New', pending: 'Pending Approval' }[policy.status],
        type: LineOfBusinessOptions.find(op => op.value === policy.type)?.label || '',
        creationType: startCase(policy.creationType),
        emit: true
      }
    })
    this.pendingCISRecordsTotal = res.recordsTotal
  }

  async getApprovedPolicies () {
    const res = await ClientPolicyService.listPoliciesV2({
      pagination: this.currentDatatablePage,
      limit: this.pageSize,
      status: ['approved_by_ops'],
      search: this.txtSearch
    })

    this.approvedPolicies = res.data.map(policy => {
      return {
        ...policy,
        applicationDate: this.dateService.format(policy.applicationDate, 'YYYY-MM-DD'),
        opsApprovalDate: this.dateService.format(policy.opsApprovalDate, 'YYYY-MM-DD'),
        status: 'Approved By Ops',
        type: LineOfBusinessOptions.find(op => op.value === policy.type)?.label || '',
        creationType: startCase(policy.creationType),
        emit: true
      }
    })
    this.approvedRecordsTotal = res.recordsTotal
  }

  async getRejectedPolicies () {
    const res = await ClientPolicyService.listPoliciesV2({
      pagination: this.currentDatatablePage,
      limit: this.pageSize,
      status: ['rejected'],
      search: this.txtSearch
    })

    this.rejectedPolicies = res.data.map(policy => {
      return {
        ...policy,
        applicationDate: this.dateService.format(policy.applicationDate, 'YYYY-MM-DD'),
        opsApprovalDate: 'No Ops Approval Date Set',
        status: 'Rejected By Ops',
        type: LineOfBusinessOptions.find(op => op.value === policy.type)?.label || '',
        creationType: startCase(policy.creationType),
        emit: true
      }
    })
    this.rejectedRecordsTotal = res.recordsTotal
  }

  get tableColumn (): { label: string; field: keyof ClientPolicyMeta }[] {
    return [
      { label: 'New Business ID', field: 'businessId' },
      { label: 'Client Name', field: 'ownersName' },
      { label: 'Provider', field: 'principal' },
      { label: 'Product Name', field: 'name' },
      { label: 'Date of Application/Submission', field: 'applicationDate' },
      { label: 'Application Status Date', field: 'opsApprovalDate' },
      { label: 'Application Status', field: 'status' },
      { label: 'LOB', field: 'type' },
      { label: 'Policy Number / Investment Number', field: 'policyNumber' },
      { label: 'Creation Type', field: 'creationType' }
    ]
  }

  get amlCsvModel () {
    return AMLCsvModel
  }

  // get existingPolicyCsvModel () {
  //   return ExistingPolicyCsvModel
  // }

  get nbrCSvImportModel () {
    return NbrCsvImportModelV2
  }

  async viewPolicyDetails (policy: ClientPolicyMeta) {
    await this.$router.push({ name: 'Policy', params: { policyOid: policy.oid } })
  }

  onPageChange (currentPage: number) {
    this.currentDatatablePage = currentPage
    this.updateRouterQuery({ page: currentPage.toString() })
  }

  onPageSizeChange (pageSize: number) {
    this.pageSize = pageSize
    this.updateRouterQuery({ page: this.currentDatatablePage })
  }

  downloadCsv (csv: string, fileName: string) {
    // const { companyOid, userOid, startDate, endDate, status } = this.exportFilter
    // const companyName = this.companyList.find(company => company.oid === companyOid)?.companyDetailsName.toUpperCase() || 'ALL_COMPANIES'
    // const userName = this.userList.find(user => user.oid === userOid)?.names[0].toUpperCase() || 'ALL_USERS'
    // const startDateConverted = this.dateService.format(startDate, 'YYYY-MM-DD')
    // const endDateConverted = this.dateService.format(endDate, 'YYYY-MM-DD')
    // const statusUpperCase = status.toUpperCase()

    const blob = new Blob([csv], { type: 'text/csv' })
    // download(blob, `${fileName.toUpperCase()}_${companyName}_${userName}_${startDateConverted}_${endDateConverted}_${statusUpperCase}`)
    download(blob, `${fileName.toUpperCase()}`)
  }

  // async onCsvUploadForMassImportExistingPolicies (records: ExistingPolicyCsvModel[]) {
  //   const imported = records.map(rec => {
  //     const { adviserRepCode, adviserName, policyNumber, ownersName, ownersNric, accountType, vestingName, vestingNric, vestingPct, introducerName, introducerNric, introducerPctYear1, introducerPctRenewal, servicingName, servicingNric, servicingPct, bscClawbackStatus, bscClawbackAmount, clientRebateStatus, clientRebateAmount, startDate, approvedDate, componentCode, businessId, issuer } = rec

  //     const issuerOid = this.companyList.find(e => e.companyDetailsName === issuer)?.oid

  //     return { adviserRepCode, adviserName, policyNumber, ownersName, ownersNric, accountType, vestingName, vestingNric, vestingPct, introducerName, introducerNric, introducerPctYear1, introducerPctRenewal, servicingName, servicingNric, servicingPct, bscClawbackStatus, bscClawbackAmount, clientRebateStatus, clientRebateAmount, startDate, approvedDate, componentCode, businessId, issuer, issuer_oid: issuerOid }
  //   })

  //   this.massImportValidationErrors = await ClientPolicyService.validateExistingPolicies(imported)
  // }

  // async importExistingPolicyCsv (records: ExistingPolicyCsvModel[]) {
  //   const imported = records.map(rec => {
  //     const { adviserRepCode, adviserName, policyNumber, ownersName, ownersNric, accountType, vestingName, vestingNric, vestingPct, introducerName, introducerNric, introducerPctYear1, introducerPctRenewal, servicingName, servicingNric, servicingPct, bscClawbackStatus, bscClawbackAmount, clientRebateStatus, clientRebateAmount, startDate, approvedDate, componentCode, businessId, issuer } = rec

  //     const issuerOid = this.companyList.find(e => e.companyDetailsName === issuer)?.oid

  //     return { adviserRepCode, adviserName, policyNumber, ownersName, ownersNric, accountType, vestingName, vestingNric, vestingPct, introducerName, introducerNric, introducerPctYear1, introducerPctRenewal, servicingName, servicingNric, servicingPct, bscClawbackStatus, bscClawbackAmount, clientRebateStatus, clientRebateAmount, startDate, approvedDate, componentCode, businessId, issuer, issuer_oid: issuerOid }
  //   })

  ///
  /// V2
  ///

  // CSV Validation
  async onCsvUploadForMassImportExistingPolicies (records: NbrCsvImportModelV2[]) {
    const imported = records.map(rec => {
      const { mainOwner, mainPolicyNumber, jointOwner, lifeAssuredOne, lifeAssuredTwo, thirdPartyPayor, adviser, beneficialOwner, policy, policyNumber } = rec
      const issuerOid = this.companyList.find(e => e.companyDetailsName === policy.principal)?.oid
      policy.productMetadata.issuer_oid = issuerOid
      return { mainOwner, jointOwner, mainPolicyNumber, lifeAssuredOne, lifeAssuredTwo, thirdPartyPayor, adviser, beneficialOwner, policy, policyNumber }
    })
    this.massImportValidationErrors = await ClientPolicyService.validateNbrImportV2(imported)
  }

  // NBR CSV Import
  async importExistingPolicyCsv (records: NbrCsvImportModelV2[]) {
    const imported = records.map(rec => {
      const { mainOwner, mainPolicyNumber, jointOwner, lifeAssuredOne, lifeAssuredTwo, thirdPartyPayor, adviser, beneficialOwner, policy, policyNumber } = rec
      const issuerOid = this.companyList.find(e => e.companyDetailsName === policy.principal)?.oid
      policy.productMetadata.issuer_oid = issuerOid
      return { mainOwner, jointOwner, mainPolicyNumber, lifeAssuredOne, lifeAssuredTwo, thirdPartyPayor, adviser, beneficialOwner, policy, policyNumber }
    })

    await ClientPolicyService.importNbrCsvV2(imported)
    this.newBusinessModal = false
    window.location.reload()
  }
  ///
  /// End V2
  ///

  async exportAml () {
    // const { creationStartDate, creationEndDate, status } = this.exportFilter

    // if (!creationStartDate || !creationEndDate || !status) {
    //   throw new Error('Start Date, End Date and Status are required')
    // }

    // const res = await ClientPolicyService.generateAmlReport(this.exportFilter)

    // this.downloadCsv(res, 'AML')
  }

  async callForFilter (filterModel: ClientPolicySearchDTO) {
    const filteringId = 'filteringList'
    this.uiService.loading.addLoadingTask(filteringId)
    try {
      const res = await ClientPolicyService.generateReconReportV2(filterModel)
      this.downloadCsv(res, 'RECON-REPORT')
    } catch (error) {
      await this.uiService.alert.show({
        type: 'error',
        message: error
      })
    } finally {
      this.uiService.loading.removeLoadingTask(filteringId)
    }
  }

  async exportRecon () {
    const { creationStartDate, creationEndDate, status } = this.exportFilter

    if (!creationStartDate || !creationEndDate || !status) {
      throw new Error('Start Date, End Date and Status are required')
    }
    try {
      const res = await ClientPolicyService.generateReconReportV2(this.exportFilter)
      this.downloadCsv(res, 'RECON-REPORT')
    } catch (error) {
      await this.uiService.alert.show({
        type: 'error',
        message: error
      })
    }
  }

  async importAmlCsv () {
    try {
      this.isImporting = true
    } finally {
      this.isImporting = false
    }
  }

  changeTab (event: Event, tab: Tab): void {
    const div = event.target as HTMLDivElement
    if (div.classList.contains('active')) {
      return
    }
    this.tab = tab
    this.txtSearch = ''
    this.currentDatatablePage = 1
    this.updateRouterQuery({ tab: tab, page: this.currentDatatablePage })
    this.updateTable()
  }

  createNewBusiness () {
    this.newBusinessModal = true
  }

  async saveNewBusiness () {
    if (this.newBusiness.adviserOid == null) {
      await this.uiService.alert.show({
        type: 'warning',
        message: 'Representative is missing'
      })
      return
    }
    this.savingInProgress = true
    try {
      const res = await ClientPolicyService.saveNewBusinessV2(this.newBusiness)
      await this.$router.push({ name: 'Policy', params: { policyOid: res.oid } })
    } catch (err) {
      console.error(err)
      this.uiService.alert.show({
        type: 'error',
        message: 'Unable to create new business.'
      })
    } finally {
      this.savingInProgress = false
    }
  }

  async fetchUsers () {
    const queryHeader = ['_oid', 'names', 'fullname', 'systemrole', 'status']
    const res: { data: Array<any[]> } = await this.$api.account.list({
      groupStatus: 'user',
      headers: JSON.stringify(queryHeader)
    })

    this.userList = res.data.map(userMeta => {
      const user = new UserMeta()
      user.assignData(queryHeader, userMeta)
      return user
    })
  }

  async fetchCompanies () {
    const queryHeader = ['_oid', 'company_details_name']
    const res: { data: Array<any[]> } = await this.$api.companyDetails.list({
      headers: JSON.stringify(queryHeader)
    })

    this.companyList = res.data.map(companyMeta => {
      const company = new CompanyDetailsMeta()
      company.assignData(queryHeader, companyMeta)
      return company
    })
  }

  async checkQuery () {
    const tab = this.$router.currentRoute.query.tab as Tab
    const search = this.$router.currentRoute.query.search
    const page = this.$router.currentRoute.query.page
    this.tab = tab || 'pending'
    this.txtSearch = search ? search.toString() : ''
    this.currentDatatablePage = page ? Number(page) : 1
    this.updateDatatablePage()
  }

  updateRouterQuery (newQuery) {
    const query = Object.assign({}, this.$route.query)
    delete query.redirect_uri
    this.$router.replace({ query: { ...query, ...newQuery } })
    this.updateDatatablePage()
  }

  updateDatatablePage () {
    if (this.tab === 'dashboard') return
    this.$nextTick(async function () {
      const datatable = this.$refs[this.tab] as any
      datatable.currentPage = this.currentDatatablePage
      if (this.tab === 'pending') {
        this.getPendingPolicies()
      } else if (this.tab === 'pending-cis-funds') {
        await this.getPendingCISPolicies()
      } else if (this.tab === 'approved') {
        this.getApprovedPolicies()
      } else if (this.tab === 'rejected') {
        this.getRejectedPolicies()
      }
    })
  }

  onSearch (search) {
    clearTimeout(this.searchTimeout)

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    this.searchTimeout = setTimeout(function () {
      that.currentDatatablePage = 1
      that.updateRouterQuery({ search, page: this.currentDatatablePage })
    }, 1000)
  }

  async applyFilters () {
    this.filters = []
    Object.keys(this.filterModel).forEach(key => {
      if (this.filterModel[key]) {
        this.filters.push({
          key,
          value: this.filterModel[key]
        })
      }
    })
    this.updateTable()
    this.filterModal = false
  }

  updateTable () {
    if (!this.filters.length || this.tab === 'dashboard') return
    this.filteredData = this[`${this.tab}Policies`].filter(value => {
      const date = new Date(value.applicationDate).getTime()
      const check = date >= this.filterModel.from && date <= this.filterModel.to
      return check
    })
  }

  closeModal () {
    this.newBusinessModal = false
    this.massImport = false
  }

  async mounted () {
    this.uiService = this.sharedVariable.uiService
    await this.fetchUsers()
    await this.fetchCompanies()
    await this.checkQuery()
    await this.retrieveClientList()
  }
}
